module.exports = __webpack_public_path__ + "img/toast-success.d4c9a203.svg";